import { Link, Navigate } from 'react-router-dom'

import { api } from '../api'
import { notierungenApi } from '../api_notierungen'
import { BEREICHE, type Bereich } from '../bereiche'
import { useLaden } from '../hooks'
import { useSitzung } from '../sitzung'
import type { BereichId } from '../typen'

/**
 * Die Startseite nach der Anmeldung: je erlaubtem Bereich eine Kachel mit Titel, einem Satz, was der
 * Bereich ist, und einer Zeile, was dort gerade ansteht. Darf jemand nur einen Bereich öffnen, gibt es
 * nichts zu wählen - dann direkt hinein.
 */
export default function BereichAuswahlSeite() {
  const { benutzer, bereiche } = useSitzung()
  if (bereiche.length === 1) return <Navigate to={BEREICHE.find((b) => b.id === bereiche[0])!.startpfad} replace />
  const sichtbar = BEREICHE.filter((b) => bereiche.includes(b.id))

  return (
    <section className="bereichsauswahl">
      <h2>Guten Tag, {benutzer.anzeigename}</h2>
      <p className="hinweis">Womit möchten Sie arbeiten?</p>
      {sichtbar.length === 0 && (
        <p className="leer">Ihrem Zugang ist noch kein Bereich freigegeben. Bitte bei der Verwaltung melden.</p>
      )}
      <div className="bereich-kacheln">
        {sichtbar.map((b) => (
          <Link key={b.id} className="bereich-kachel" to={b.startpfad}>
            <span className="bereich-titel">{b.titel}</span>
            <span className="bereich-text">{b.kurztext}</span>
            <LiveZeile bereich={b} />
          </Link>
        ))}
      </div>
    </section>
  )
}

/** Was im Bereich gerade ansteht - aus Endpunkten, die es ohnehin gibt. */
async function liveText(id: BereichId): Promise<string> {
  if (id === 'notierungen') return (await notierungenApi.heute()).zusammenfassung
  const [rueckfragen, importe] = await Promise.all([api.rueckfragen(), api.importe('offen')])
  const teile = [
    rueckfragen.length === 1 ? '1 offene Rückfrage' : `${rueckfragen.length} offene Rückfragen`,
    importe.length === 1 ? '1 Import zur Freigabe' : `${importe.length} Importe zur Freigabe`,
  ]
  return rueckfragen.length === 0 && importe.length === 0 ? 'Keine offenen Rückfragen, kein Import wartet.' : `${teile.join(', ')}.`
}

function LiveZeile({ bereich }: { bereich: Bereich }) {
  const { daten, fehler } = useLaden(() => liveText(bereich.id), [bereich.id])
  return (
    <span className="bereich-live" aria-live="polite">
      {daten ?? (fehler ? 'Stand gerade nicht abrufbar.' : 'Stand wird geladen…')}
    </span>
  )
}
